import { values } from "lodash";

export const CATEGORY_CHOICES = [
  { label: "automotive", value: "Automotive" },
  { label: "payment services", value: "Payment Services" },
  { label: "beauty & health", value: "Beauty & Health" },
  { label: "business services", value: "Business Services" },
  { label: "dealers and distributors", value: "Dealers And Distributors" },
  { label: "education", value: "Education" },
  { label: "fashion", value: "Fashion" },
  { label: "food and beverages", value: "Food And Beverages" },
  { label: "home-based business", value: "Home-Based Business" },
  { label: "hotel, travel & tourism", value: "Hotel, Travel & Tourism" },
  { label: "retail", value: "Retail" },
  { label: "SFE", value: "SFE" },
];
export const SUB_CATEGORY_CHOICES = [
  { label: "auto_mobile_Related", value: "Automobile Related" },
  { label: "entertainment_leisure", value: "Entertainment & Leisure" },
  { label: "supermarkets_marts", value: "Supermarkets & Marts" },
  { label: "home_office", value: "Home & Office" },
  { label: "fashion", value: "Fashion" },
  { label: "e_retail", value: "E-Retail" },
  { label: "consumer_durables_it", value: "Consumer Durables & It" },
  { label: "books_toys_gifts", value: "Books, Toys & Gifts" },
  { label: "tourism_services", value: "Tourism Services" },
  { label: "taxi_rental", value: "Taxi & Rental" },
  { label: "hotels_resorts", value: "Hotels & Resorts" },
  { label: "technology_related", value: "Technology Related" },
  { label: "repair_services", value: "Repair Services" },
  { label: "home_care_services", value: "Home Care Services" },
  { label: "home_based_tutoring", value: "Home Based Tutoring" },
  { label: "home_based_manufacturing", value: "Home Based Manufacturing" },
  {
    label: "home_based_food_preparation",
    value: "Home Based Food Preparation",
  },
  { label: "home_based_businesses", value: "Home Based Businesses" },
  { label: "business_services", value: "Business Services" },
  { label: "beauty_fitness", value: "Beauty & Fitness" },
  { label: "restaurant_night_clubs", value: "Restaurant & Night Clubs" },
  { label: "quick_bites", value: "Quick Bites" },
  { label: "food_beverage", value: "Food & Beverage" },
  { label: "catering_food_ordering", value: "Catering & Food Ordering" },
  { label: "cafe_parlors", value: "Cafe & Parlors" },
  { label: "bakery_sweets_ice_cream", value: "Bakery, Sweets & Ice Cream" },
  { label: "luxury_premium", value: "Luxury/Premium" },
  { label: "jewelry", value: "Jewelry" },
  { label: "footwear", value: "Footwear" },
  { label: "clothing", value: "Clothing" },
  { label: "accessories", value: "Accessories" },
  { label: "vocational_training", value: "Vocational Training" },
  { label: "online_education", value: "Online Education" },
  { label: "k12_education", value: "K-12 Education" },
  { label: "higher_education", value: "Higher Education" },
  { label: "education_services", value: "Education Services" },
  { label: "education_consultants", value: "Education Consultants" },
  { label: "early_education", value: "Early Education" },
  { label: "coaching_tutoring", value: "Coaching & Tutoring" },
  {
    label: "sports_fitness_entertainment",
    value: "Sports Fitness and Entertainment",
  },
  { label: "security_protection", value: "Security and Protection" },
  { label: "offices_supplies", value: "Offices Supplies" },
  {
    label: "medical_hospital_supplies",
    value: "Medical and Hospital Supplies",
  },
  { label: "industrials_supplies", value: "Industrials Supplies" },
  { label: "industrials_machineries", value: "Industrials Machineries" },
  { label: "home_supplies", value: "Home Supplies" },
  {
    label: "health_care_medical_pharma",
    value: "Health Care Medical and Pharma",
  },
  { label: "health_beauty", value: "Health and Beauty" },
  { label: "food_beverages", value: "Food and Beverages" },
  { label: "fashion_aprils", value: "Fashion and Aprils" },
  { label: "environment_pollution", value: "Environment and Pollution" },
  { label: "electronics_electricals", value: "Electronics and Electricals" },
  { label: "educational", value: "Educational" },
  {
    label: "computer_hardware_mobile_accessory",
    value: "Computer Hardware And Mobile accessory",
  },
  { label: "building_construction", value: "Building and Construction" },
  { label: "automobile", value: "Automobile" },
  { label: "agriculture", value: "Agriculture" },
  {
    label: "waste_management_recycling_services",
    value: "Waste Management & Recycling Services",
  },
  { label: "travel", value: "Travel" },
  { label: "real_estate", value: "Real Estate" },
  { label: "logistics", value: "Logistics" },
  { label: "it_services", value: "IT Services" },
  { label: "household_services", value: "Household Services" },
  { label: "financial", value: "Financial" },
  { label: "consultancy", value: "Consultancy" },
  {
    label: "advertisement_media_services",
    value: "Advertisement & Media Services",
  },
  { label: "wellness", value: "Wellness" },
  { label: "health_care", value: "Health Care" },
  {
    label: "beauty_aesthetics_supplies",
    value: "Beauty Aesthetics & Supplies",
  },
  { label: "online_banking_payments", value: "Online Banking Payments" },
  { label: "point_of_sale_pos_systems", value: "Point-of-Sale (POS) Systems" },
  { label: "cryptocurrency_payments", value: "Cryptocurrency Payments" },
  { label: "digital_wallets", value: "Digital Wallets" },
  { label: "mobile_payments", value: "Mobile Payments" },
  { label: "payment_gateways", value: "Payment Gateways" },
  { label: "two_wheeler", value: "Two Wheeler" },
  { label: "four_wheeler", value: "Four Wheeler" },
  { label: "commercial_vehicle", value: "Commercial Vehicle" },
  {
    label: "sports_Goods_Fitness_Stores",
    value: "Sports Goods & Fitness Stores",
  },
];
export const FRANCHISE_MODEL = [
  { label: "FOFO", value: "FOFO" },
  { label: "FOCO", value: "FOCO" },
  { label: "FICO", value: "FICO" },
  { label: "COCO", value: "COCO" },
  { label: "COFO", value: "COFO" },
];
export const INVESTMENT_RANGE = [
  { label: "Under 1 Lakh", value: "₹10K - ₹1 Lac" },
  { label: "Under 2 Lakh", value: "₹1 Lac - ₹2 Lac" },
  { label: "Under 3 Lakh", value: "₹2 Lac - ₹3 Lac" },
  { label: "Under 4 Lakh", value: "₹3 Lac - ₹4 Lac" },
  { label: "Under 5 Lakh", value: "₹4 Lac - ₹5 Lac" },
  { label: "Under 10 Lakh", value: "₹5 Lac - ₹10 Lac" },
  { label: "Under 20 Lakh", value: "₹10 Lac - ₹20 Lac" },
  { label: "Under 30 Lakh", value: "₹20 Lac - ₹30 Lac" },
  { label: "Under 40 Lakh", value: "₹30 Lac - ₹40 Lac" },
  { label: "Under 50 Lakh", value: "₹40 Lac - ₹50 Lac" },
  { label: "Under 1 Cr", value: "₹50 Lac - ₹1 Cr" },
  { label: "Under 2 Cr", value: "₹1 Cr - ₹2 Cr" },
  { label: "Under 5 Cr", value: "₹2 Cr - ₹5 Cr" },
  { label: "Under 10 Cr", value: "₹5 Cr - ₹10 Cr" },
  { label: "Above 10 Cr", value: "₹10 Cr - Above" },
];
export const PROFILE_TYPE = [
  { label: "investor", value: "investor" },
  { label: "lender", value: "lender" },
  { label: "mentor", value: "mentor" },
  { label: "incubation", value: "incubation" },
];
export const PURCHASE_TIME = [
  { label: "3 month", value: "3 month" },
  { label: "6 month", value: "6 month" },
  { label: "9 month", value: "9 month" },
  { label: "1 year", value: "1 year" },
  { label: "2 year", value: "2 year" },
];
export const INTERNET_CONNECTION = [
  { label: "yes", value: "Yes" },
  { label: "no", value: "No" },
];

//loan for bussiness sections

export const LOAN_RANGE = [
  { label: "0 - 1,500,000", value: "0-15lac" },
  { label: "1,500,000 -30,00,000", value: "15-30lac" },
  { label: "30,00,000 -50,00,000", value: "30-50lac" },
  { label: "50,00,000 - 1,00,00,000", value: "50-1cr" },
  { label: "1,00,00,000 - 5,00,00,000", value: "1-5cr" },
  { label: "Above 5,00,00,000", value: "Above5cr" },
];
export const PROPERTY_CHOICE = [
  { label: "Residential", value: "residential" },
  { label: "Commercial", value: "commercial" },
  { label: "Godown", value: "godown" },
  { label: "Garage", value: "garage" },
  { label: "Warehouse", value: "warehouse" },
  { label: "Land", value: "land" },
];
export const SIZE_CHOICE = [
  { label: "under-500qr ft", value: "under-500qr ft" },
  { label: "500qr ft-1000qr ft", value: "500qr ft-1000qr ft" },
  { label: "1000qr ft-above", value: "1000qr ft-above" },
];

//floor area json
export const FLOOR_AREA_JASON = [
  { label: "50-100 Sq Ft", value: "50-100 Sq Ft" },
  { label: "100-200 Sq Ft", value: "100-200 Sq Ft" },
  { label: "200-500 Sq Ft", value: "200-500 Sq Ft" },
  { label: "500-2000 Sq Ft", value: "500-2000 Sq Ft" },
  { label: "2000-above Sq Ft", value: "2000-above Sq Ft" },
]
//channelpartner 

export const EMPLOYMENT_CHOICES = [
  { value: 'pvt_job', label: 'Pvt. Job' },
  { value: 'govt_job', label: 'Govt. Job' },
  { value: 'student', label: 'Student' },
  { value: 'self_employed', label: 'Self-Employed' },
  { value: 'other', label: 'Other' },
]
export const EDUCATION_CHOICES = [
  { value: '10th', label: '10th' },
  { value: '10+2', label: '10+2' },
  { value: 'graduate', label: 'Graduate' },
  { value: 'post_graduate', label: 'Post Graduate' },
  { value: 'phd', label: 'PhD' },
  { value: 'other', label: 'Other' },
]


//section choice
export const SECTION_CHOICE = [
  { id: "trending franchises today", name: "Trending Franchises Today" },
  {
    id: "premium franchise opportunities",
    name: "Premium Franchise Opportunities",
  },
  {
    id: "top international opportunities",
    name: "Top International Opportunities",
  },
  { id: "upcoming events", name: "Upcoming Events" },
  { id: "top franchise opportunities", name: "Top Franchise Opportunities" },
  {
    id: "featured Ffranchise companies",
    name: "Featured Franchise Companies",
  },
];

// statedata
export const STATE_DATA = [
  { code: "AN", value: "Andaman and Nicobar Islands" },
  { code: "AP", value: "Andhra Pradesh" },
  { code: "AR", value: "Arunachal Pradesh" },
  { code: "AS", value: "Assam" },
  { code: "BR", value: "Bihar" },
  { code: "CG", value: "Chandigarh" },
  { code: "CH", value: "Chhattisgarh" },
  { code: "DH", value: "Dadra and Nagar Haveli" },
  { code: "DD", value: "Daman and Diu" },
  { code: "DL", value: "Delhi" },
  { code: "GA", value: "Goa" },
  { code: "GJ", value: "Gujarat" },
  { code: "HR", value: "Haryana" },
  { code: "HP", value: "Himachal Pradesh" },
  { code: "JK", value: "Jammu and Kashmir" },
  { code: "JH", value: "Jharkhand" },
  { code: "KA", value: "Karnataka" },
  { code: "KL", value: "Kerala" },
  { code: "LD", value: "Lakshadweep" },
  { code: "MP", value: "Madhya Pradesh" },
  { code: "MH", value: "Maharashtra" },
  { code: "MN", value: "Manipur" },
  { code: "ML", value: "Meghalaya" },
  { code: "MZ", value: "Mizoram" },
  { code: "NL", value: "Nagaland" },
  { code: "OR", value: "Odisha" },
  { code: "PY", value: "Puducherry" },
  { code: "PB", value: "Punjab" },
  { code: "RJ", value: "Rajasthan" },
  { code: "SK", value: "Sikkim" },
  { code: "TN", value: "Tamil Nadu" },
  { code: "TS", value: "Telangana" },
  { code: "TR", value: "Tripura" },
  { code: "UK", value: "Uttarakhand" },
  { code: "UP", value: "Uttar Pradesh" },
  { code: "WB", value: "West Bengal" },
];

// Date Format
export const dateFormatter = (date, sep = "") => {
  const dateObj = new Date(date);
  const dateOptions = { year: "numeric", month: "short", day: "numeric" };
  const formattedDate = dateObj
    .toLocaleDateString("en-GB", dateOptions)
    .replace(/,/g, sep);

  return formattedDate;
};

export const timeFormatter = (date) => {
  const timeOptions = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  const formattedTime = new Date(date).toLocaleTimeString("en-US", timeOptions);

  return formattedTime;
};
// extract numeric value

export const extractNumericValue = (investment) => {
  // Replace 'K', 'LAC', 'CR' with their numeric equivalents
  let numericValue = investment
    .replace("K", "000")
    .replace("LAC", "00000")
    .replace("CR", "0000000");
  // Remove any remaining non-numeric characters
  numericValue = numericValue.replace(/[^0-9]/g, "");
  return parseInt(numericValue, 10);
};

//date formatter
export function formatDate(dateStr) {
  // Create a new Date object from the date string
  const date = new Date(dateStr);

  // Check if the date is valid
  if (isNaN(date)) {
    throw new Error("Invalid date string");
  }

  // Get day, month, and year
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();

  // Combine into the desired format
  return `${day} ${month} ${year}`;
}

export const formatDateTime = (dateString) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", options);
};

export const formatTime = (dateString) => {
  const date = new Date(dateString);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const startHour = hours % 12 || 12;
  const endHour = (hours + 3) % 12 || 12;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${startHour}:${formattedMinutes} ${ampm} - ${endHour}:${formattedMinutes} ${ampm}`;
};

//emoji validation
export const emojiPattern = /[\p{Emoji}]/u;

//alphabet/nmbers
export const specialCharacterPattern = /[^a-zA-Z0-9\s]/;
const websitePattern = /\.(com|in)$/;
//valid domain
export const multipleDomainsPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+\.[^\s@]+$/;
